import { render, staticRenderFns } from "./figure.vue?vue&type=template&id=66000a90&scoped=true&lang=pug&"
var script = {}
import style0 from "./figure.vue?vue&type=style&index=0&id=66000a90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66000a90",
  null
  
)

export default component.exports